import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useState } from "react";
export default function DataGridTable({ allTeacher, appliedUniversities,
  appliedTimelines,
  appliedTerms,
  appliedPrograms }) {

  const navigate = useNavigate();
  const handleRowClick = (params) => {

    navigate(`/individualteacher`, {
      state: {
        teacherName: params.row.lfname,
        teacherid: params.row.ifid,
        appliedTerms,
        appliedTimelines,
        appliedUniversities,
        appliedPrograms,
        selectedUniversities: appliedUniversities,
      },
    });
  };

  // const columns = [
  //   { field: "sno", headerName: "S.no", width: 80 },
  //   {
  //     field: "lfname",
  //     headerName: "LF Name",
  //     flex: 1, // Use flex to make column responsive
  //     minWidth: 120,
  //   },
  //   // {
  //   //   field: "mentored",
  //   //   headerName: "Mentored LF",
  //   //   flex: 1, // Use flex to make column responsive
  //   //   minWidth: 120,
  //   // },
  //   {
  //     field: "lfcategory",
  //     headerName: "LF Category",
  //     flex: 1, // Use flex for responsive layout
  //     minWidth: 100,
  //   },
  //   {
  //     field: "percentageofstudent",
  //     headerName: " Students Engaged in 1-1 Sessions (%)",
  //     flex: 2, // Give more space to this column
  //     minWidth: 200,

  //     renderCell: (params) => {
  //       const percentageofstuaduiovideo = parseFloat(params.row.percentageofstudent); // Current avg duration
  //       const percentageofstuaduiovideoth = parseFloat(params.row.percentangeofstuentth); // Threshold value

  //       // Apply red color if avg duration is less than the threshold
  //       const style = percentageofstuaduiovideo < percentageofstuaduiovideoth ? { color: "red" } : {};

  //       return (
  //         <div style={style}>
  //           {params.value}
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     field: "avgdur",
  //     headerName: " Average Duration per Session (Min.)",
  //     flex: 1,
  //     minWidth: 150,
  //     renderCell: (params) => {
  //       const avgDuration = parseFloat(params.row.avgdur); // Current avg duration
  //       const avgTimeThreshold = parseFloat(params.row.avgtimeth); // Threshold value

  //       // Apply red color if avg duration is less than the threshold
  //       const style = avgDuration < avgTimeThreshold ? { color: "red" } : {};

  //       return (
  //         <div style={style}>
  //           {params.value}
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     field: "percentageresponded",
  //     headerName: "Messages Responded to in 60 min",
  //     flex: 2,
  //     minWidth: 200,
  //     renderCell: (params) => {
  //       const percentageresponded = parseFloat(params.row.percentageresponded); // Current avg duration
  //       const percentagerespondedth = parseFloat(params.row.percentagerespondth); // Threshold value

  //       // Apply red color if avg duration is less than the threshold
  //       const style = percentageresponded < percentagerespondedth ? { color: "red" } : {};

  //       return (
  //         <div style={style}>
  //           {params.value}
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     field: "callqualityscore",
  //     headerName: " Quality Score for Student Sessions",
  //     flex: 2,
  //     minWidth: 180,
  //   },
  //   {
  //     field: "redflagpercent",
  //     headerName: "Calls With Red Flags (%)",
  //     flex: 1,
  //     minWidth: 150,
  //   },
  //   {
  //     field: "complianceredflags",
  //     headerName: "Compliance Red Flags Raised",
  //     flex: 1,
  //     minWidth: 180,
  //   },
  //   {
  //     field: "assessmentfeedback",
  //     headerName: "Grading quality score",
  //     flex: 1,
  //     minWidth: 200,
  //   },
  // ];
  // Check if tableData is valid before mapping
  // const rows = (allTeacher || []).map((item, index) => ({
  //   id: index + 1,  // Add a unique `id` here
  //   sno: index + 1,
  //   lfname:item.lf_name,
  //   mentored: item.mentored_status,
  //   lfcategory: item.lf_category,
  //   percentageofstudent: item.students_engaged_in_phone_video,
  //   percentangeofstuentth:item.students_engaged_in_phone_video_threshold,
  //   avgdur: item.average_time_per_call,
  //   avgtimeth:item.average_time_per_call_threshold,
  //   percentageresponded: item.percentage_of_messages_responded,
  //   percentagerespondth:item.percentage_of_messages_responded_threshold,
  //   callqualityscore: item.call_quality_score,
  //   redflagpercent: item.red_flags_percentage,
  //   complianceredflags: item.compliance_flags,
  //   assessmentfeedback: item.assessment_feedback,

  // }));


  const columns = [
    {
      field: "sno", headerName: "S.no", width: 100, headerAlign: "left", align: "left",
      sortable: false, // Prevent sorting on S.No
      renderCell: (params) => params.api.getRowIndexRelativeToVisibleRows(params.id) + 1
    },
    {
      field: "lfname",
      headerName: "Name",
      flex: 1, minWidth: 120, headerAlign: "left", align: "left"
    },
    {
      field: "lfcategory",
      headerName: "Category",
      flex: 1,
      minWidth: 120,
      align: "center",
      headerAlign: "center",
    },
    // { field: "studentengaged", headerName: "Students Engaged (%)", flex: 1, minWidth: 120, headerAlign: "center", align: "center" },
       {
      field: "studentengaged",
      headerName: "Students Engaged (%)",
      flex: 1,
      minWidth: 120,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const value = Number(params.value);
        return isNaN(value) ? " " : `${value.toFixed(0)}%`;
      },
    },
    {
      field: "percentageofstudent",
      headerName: "Students Engaged in 1-1 Sessions (%)",
      flex: 2,
      minWidth: 200,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const value = parseFloat(params.value) || 0;
        const threshold = parseFloat(params.row.percentangeofstuentth) || 0;
        const style = value < threshold ? { color: "red" } : {};
        return <div style={style}>{`${value}%`}</div>;
      },
    },
    {
      field: "avgdur",
      headerName: "Avg. 1-1 Session Duration (Min)",
      flex: 1,
      minWidth: 150,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const value = parseFloat(params.value) || 0;
        const threshold = parseFloat(params.row.avgtimeth) || 0;
        const style = value < threshold ? { color: "red" } : {};
        return <div style={style}>{value.toFixed(0)}</div>;
      },
    },
    {
      field: "percentageresponded",
      headerName: "Messages Responded Within 60 Mins (%)",
      flex: 2,
      minWidth: 200,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const value = Math.round(parseFloat(params.value) || 0);
        const threshold = parseFloat(params.row.percentagerespondth) || 0;
        const style = value < threshold ? { color: "red" } : {};
        return <div style={style}>{`${value}%`}</div>;
      },
    },
    {
      field: "callqualityscore",
      headerName: "1-1 Sessions Quality Score",
      flex: 2, minWidth: 180, headerAlign: "center", align: "center"
    },
    {
      field: "redflagpercent",
      headerName: "1-1 Sessions with Red Flags (%)",
      flex: 1,
      minWidth: 150,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => `${params.value}%`,
    },
    {
      field: "groupsessionqualityscore",
      headerName: "Group Sessions Quality Score",
      flex: 1,
      minWidth: 150,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => `${params.value}%`,
    },

    {
      field: "complianceredflags",
      headerName: "Compliance Red Flags Raised",
      flex: 1,
      minWidth: 180,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "assessmentfeedback",
      headerName: "Grading Quality Score",
      flex: 1,
      minWidth: 200,
      align: "center",
      headerAlign: "center",
    },
  ];

  const rows = (allTeacher || []).map((item, index) => ({
    id: index + 1,
    sno: index + 1,
    lfname: item.lf_name,
    ifid: item.id,
    lfcategory: item.lf_category,
    percentageofstudent: item.students_engaged_in_phone_video,
    percentangeofstuentth: item.students_engaged_in_phone_video_threshold,
    avgdur: item.average_time_per_call,
    avgtimeth: item.average_time_per_call_threshold,
    percentageresponded: item.percentage_of_messages_responded,
    groupsessionqualityscore: item.average_group_session_quality_score,
    percentagerespondth: item.percentage_of_messages_responded_threshold,
    callqualityscore: item.call_quality_score,
    studentengaged: item.percentage_total_students_engaged,
    redflagpercent: item.red_flags_percentage,
    complianceredflags: item.compliance_flags,
    assessmentfeedback: item.assessment_feedback,
  }));
  const [paginationModel, setPaginationModel] = useState({
    page: 0, // Starts at the first page
    pageSize: 20, // Shows 20 rows by default
  });
  return (
    <div style={{ width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        pagination
        paginationModel={paginationModel}
        onPaginationModelChange={(newModel) => setPaginationModel(newModel)}
        autoHeight
        rowCount={rows.length} // Ensure correct total row count
        pageSizeOptions={[20, 50, 100]} // Available page sizes
        onRowClick={handleRowClick}
        sx={{
          'fontFamily': 'Nunito Sans, sans-serif',
          'fontSize': '14px',
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#ebebeb',
            color: '#000',
            fontWeight: 'bold',
            fontSize: '14px',
            padding: '6px',
            fontFamily: 'Nunito Sans, sans-serif',
          },
          '& .MuiDataGrid-cell': {
            padding: '6px',
            fontFamily: 'Nunito Sans, sans-serif',
            fontSize: '14px',
          },
          '& .MuiDataGrid-row:hover': {
            cursor: 'pointer',
            backgroundColor: '#f5f5f5',
          },
        }}
      />
    </div>
  );
}
